import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api, type ApiListMeta } from '../../lib/api.js';
import type { ImageRequest } from '../../lib/types.js';
import { StatusBadge } from '../../components/StatusBadge.js';

export function ImageRequestsListPage() {
  const query = useQuery({
    queryKey: ['image-requests', 'all'],
    queryFn: () =>
      api.get<ImageRequest[]>('/image-requests?pageSize=100') as Promise<{
        data: ImageRequest[];
        meta: ApiListMeta;
      }>,
  });

  return (
    <section>
      <h1>Image Requests</h1>
      {query.data && query.data.data.length === 0 && (
        <p className="muted">No image requests yet.</p>
      )}
      {query.data && query.data.data.length > 0 && (
        <table className="data-table">
          <thead>
            <tr>
              <th>Prompt</th>
              <th>Status</th>
              <th>Aspect / tier</th>
            </tr>
          </thead>
          <tbody>
            {query.data.data.map((r) => (
              <tr key={r.id}>
                <td>
                  <Link to={`/image-requests/${r.id}`}>{r.promptSnapshot.slice(0, 70)}…</Link>
                </td>
                <td>
                  <StatusBadge status={r.status} />
                </td>
                <td>
                  {r.aspectRatio} / {r.imageModelTier}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
